import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getDownloadURL, ref, getStorage } from '@angular/fire/storage';
import { LookupService } from './lookup.service';
import { CardLookupDto } from './card.lookup.dto';
import { CardFieldsPair } from '../card-entry/card-entry.component';
import { Utils } from '../utils/utils';
import { FirebaseApp } from '@angular/fire/app';
import { Currency } from '../utils/currency';
import { CardStatus } from '../../card.status';

export enum InterfaceState {
  LOADING,
  CARD_ENTRY,
  ERROR,
  SUCCESS
}

@Component({
  selector: 'app-lookup',
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.css']
})
export class LookupComponent implements OnInit {

  state = InterfaceState.CARD_ENTRY;
  interfaceState = InterfaceState;
  cardStatus = CardStatus;

  lookupObject?: CardLookupDto | null;
  pin?: string | null;
  @Output() cardId?: string | null;
  errorMessage?: string | null;

  constructor(
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private firebaseApp: FirebaseApp) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const idParameter = params.get('card_id');
      if (idParameter) {
        if (idParameter == "demo") {
          this.cardId = "0123456789ABCDEF";
          this.lookupObject = {
            id: "0123456789ABCDEF",
            current_amount: 127.50,
            initial_amount: 250,
            sender: "Luca",
            partner_name: "Negozio Demo",
            currency: Currency.EUR,
            expires_at: {
              _seconds: Math.floor(Date.now() / 1000) + 31536000, // Current date + 1 year in seconds
              _nanoseconds: 0
            },
            status: CardStatus.Active,
            card_front_thumbnail: "/assets/letscard-template-virtual.svg"
          };
          this.state = InterfaceState.SUCCESS;
        } else if (Utils.cardIdRegex.test(idParameter)) {
          this.cardId = idParameter;
          this.state = InterfaceState.CARD_ENTRY;
        } else {
          this.errorMessage = "Carta regalo non valida."
          this.state = InterfaceState.ERROR;
        }
      }
    });
  }

  onFieldsChange(pair: CardFieldsPair) {
    const cardId = pair.cardId;
    const pin = pair.pin;

    if (cardId.length == 16 && pin.length == 6 && this.pin == null) {
      this.pin = pin;
      this.cardId = cardId;
      this.state = InterfaceState.LOADING;
      this.lookupService.lookup(this.cardId ?? "", this.pin).subscribe({
        next: response => {
          this.lookupObject = response as CardLookupDto;

          const thumbPath = this.lookupObject?.card_front_thumbnail;
          if (thumbPath) {
            let thumbnailReference = ref(getStorage(this.firebaseApp), thumbPath);
            getDownloadURL(thumbnailReference).then((url: string | null | undefined) => {
              this.lookupObject!.card_front_thumbnail = url;
              this.state = InterfaceState.SUCCESS;
            });
          } else {
            this.state = InterfaceState.SUCCESS;
          }
        },
        error: error => {
          this.errorMessage = error.message;
          this.state = InterfaceState.ERROR;
        },
        complete: () => {
        }
      });
    }
  }

  get cardStatusErrorMessage(): string | null {
    switch (this.lookupObject?.status) {
      case CardStatus.Cancelled:
        return "La carta regalo è stata annullata.";
      case CardStatus.Created:
        return "La carta regalo non è ancora attiva.";
      case CardStatus.PendingActivation:
        return "La carta regalo non è ancora attiva.";
      default:
        return null;
    }
  }
}